import React from "react";
import { Label } from "@/components/ui/label";
import { Wallet } from "lucide-react";
import { paymentMethods } from "./constants";

export function PaymentMethodSelector({
  paymentMethod,
  setPaymentMethod,
  walletBalance,
  useWallet,
  setUseWallet,
  estimatedPrice,
  user
}) {
  return (
    <div className="bg-card border border-border p-6 space-y-4">
      <Label className="font-semibold text-base">Payment Method</Label>
      <div className="grid grid-cols-3 gap-3">
        {paymentMethods.map((method) => (
          <button
            key={method.id}
            type="button"
            onClick={() => {
              setPaymentMethod(method.id);
              // Disable wallet for non-online payments
              if (method.id !== 'online') setUseWallet(false);
            }}
            className={`p-4 border-2 transition-all text-center ${
              paymentMethod === method.id 
                ? "border-accent bg-accent/5" 
                : "border-border hover:border-accent/50"
            }`}
            data-testid={`payment-${method.id}`}
          >
            <method.icon className={`w-6 h-6 mx-auto mb-2 ${
              method.id === 'online' ? 'text-green-500' : 
              method.id === 'cod' ? 'text-amber-500' : 'text-blue-500'
            }`} />
            <p className="font-medium text-sm">{method.name}</p>
            <p className={`text-xs ${
              method.id === 'online' ? 'text-green-600' : 'text-amber-600'
            }`}>{method.description}</p>
          </button>
        ))}
      </div>

      {/* Wallet Balance - Only for Online Payment */}
      {user && walletBalance > 0 && paymentMethod === 'online' && (
        <div className="bg-orange-50 border border-orange-200 p-4 space-y-3 mt-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Wallet className="w-5 h-5 text-orange-500" />
              <span className="font-medium">Wallet Balance</span>
            </div>
            <span className="font-bold text-orange-600">₹{walletBalance.toFixed(2)}</span>
          </div>
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={useWallet}
              onChange={(e) => setUseWallet(e.target.checked)}
              className="w-5 h-5 accent-orange-500"
              data-testid="use-wallet-checkbox"
            />
            <span className="text-sm">
              Use wallet balance {(() => {
                if (!estimatedPrice) return "";
                if (walletBalance >= estimatedPrice) return "(covers full amount!)";
                return `(₹${Math.min(walletBalance, estimatedPrice).toFixed(2)} off)`;
              })()}
            </span>
          </label>
        </div>
      )}
    </div>
  );
}
